export const SUPER_NAV_WIDTH = 72;
export const KIT_NAV_WIDTH = 240;
